module.exports = (__webpack_require__(8722))(530);